export { default as StrategyFreshFacesBadge } from './StrategyFreshFacesBadge';
